import { authenticatedAxios } from '../../utils/axios'
import CONSTANTS from '../../utils/constants'
import ENDPOINTS from '../constant'
import axios from 'axios'
import { decrypt } from '../../utils/security'
import { getCookieValue } from '../../utils/utils'
import { defaultLanguage } from '../../translations/constant'

export const getBundles = async () => {
  let responseData = {}
  try {
    const res = await authenticatedAxios.get(`${ENDPOINTS.bundle}`)

    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData = res.data.result
    } else {
      responseData.error = res.data
    }
  } catch {
    responseData.error = 'Error while get Bundles'
  }
  return responseData
}

export const getUsageFromAPI = async (bodyData) => {
  let responseData = { data: {}, error: null }
  try {
    const res = await authenticatedAxios.post(
      `${ENDPOINTS.usage.root}`,
      bodyData
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.data = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch {
    responseData.error = 'Error while getting Usage Info'
  }
  return responseData
}

export const getAllCountries = async () => {
  let responseData = {
    allCountry: [],
    mostVisitedCountry: [],
    currentCountry: '',
    error: null,
  }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.roaming.root}${ENDPOINTS.roaming.getCountries}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.allCountry = res.data.result
      res.data.result.forEach(function (countryInfo, index) {
        if (countryInfo.recommended) {
          responseData.mostVisitedCountry.push(countryInfo)
        }
        if (countryInfo.isCurrent) {
          responseData.currentCountry = countryInfo
        }
      })
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting countries Info'
  }
  return responseData
}

export const getCountryInfo = async (countryCode) => {
  let responseData = { countryInfo: [], countryBundles: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.roaming.root}${ENDPOINTS.roaming.getCountryInfo}?countryCode=${countryCode}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.countryInfo = res.data.result.country
      responseData.countryBundles = res.data.result.listOfBundles
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting country Info'
  }
  return responseData
}

export const getCountryBundlesV2 = async (countryCodes) => {
  let responseData = { countryBundles: [], sharedBundles: [], error: null }
  try {
    const countryCodesString = countryCodes.join(',')
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.roaming.root}${ENDPOINTS.roaming.getCountryInfo}?countryCodes=${countryCodesString}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.countryBundles = res.data.result.countryBundles || []
      responseData.sharedBundles = res.data.result.sharedBundles || []
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting country bundles'
  }
  return responseData
}

export const getNationalRoamingInfo = async () => {
  let responseData = { countryInfo: [], countryBundles: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.roaming.root}${ENDPOINTS.roaming.national}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.countryInfo = res.data.result.country
      responseData.countryBundles = res.data.result.listOfBundles
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting national Info'
  }
  return responseData
}

export const checkEligbiltyForBundleGifting = async (destMsisdn) => {
  let responseData = { isEligible: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.newGifting.root}${ENDPOINTS.newGifting.checkEligibility}?destMsisdn=${destMsisdn}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.isEligible = res.data.responseMessage
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while checking eligbilty for bundle gifting'
  }
  return responseData
}

export const checkIsPlusEligible = async () => {
  try {
    const { data } = await authenticatedAxios.get(
      `${ENDPOINTS.newPlus.root}${ENDPOINTS.newPlus.isEligible}`
    )

    if (data.responseCode === CONSTANTS.SUCCESS) {
      return { status: 'eligible', result: data.result }
    }

    if (data.responseCode === -3) {
      return { status: 'plusUsers', result: data.result }
    } else {
      return {
        status: 'error',
        message: data.responseMessage,
      }
    }
  } catch (e) {
    return { status: 'error', message: 'Error while checking Plus eligibility' }
  }
}

export const getComboProducts = async () => {
  let responseData = { comboProducts: [], error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.newPlus.root}${ENDPOINTS.newPlus.getComboProducts}`
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.comboProducts = res.data.result
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while getting combo products'
  }
  return responseData
}

export const getFamilyRoamingCountries = async (destMsisdn) => {
  let responseData = {
    allCountry: [],
    mostVisitedCountry: [],
    currentCountry: '',
    error: null,
  }
  try {
    // Try different possible endpoint paths
    let res
    let lastError = null
    
    // Try 1: /merge/api/Roaming/GetFamilyRoamingCountries (absolute path)
    try {
      res = await authenticatedAxios.get(
        `/merge/api/Roaming/GetFamilyRoamingCountries?destMsisdn=${destMsisdn}`
      )
      console.log('Successfully used /merge/api/Roaming/GetFamilyRoamingCountries')
    } catch (error1) {
      lastError = error1
      // Try 2: merge/api/Roaming/GetFamilyRoamingCountries (relative to base URL)
      if (error1.response?.status === 404) {
        try {
          console.log('Trying merge/api/Roaming/GetFamilyRoamingCountries (relative path)...')
          res = await authenticatedAxios.get(
            `merge/api/Roaming/GetFamilyRoamingCountries?destMsisdn=${destMsisdn}`
          )
          console.log('Successfully used merge/api/Roaming/GetFamilyRoamingCountries')
        } catch (error2) {
          lastError = error2
          // Try 3: Standard roaming endpoint structure
          if (error2.response?.status === 404) {
            try {
              console.log('Trying standard roaming endpoint structure...')
              res = await authenticatedAxios.get(
                `${ENDPOINTS.roaming.root}/GetFamilyRoamingCountries?destMsisdn=${destMsisdn}`
              )
              console.log('Successfully used standard roaming endpoint')
            } catch (error3) {
              lastError = error3
              throw error3
            }
          } else {
            throw error2
          }
        }
      } else {
        throw error1
      }
    }
    // Handle both ResponseCode (API spec) and responseCode (common pattern)
    const responseCode = res.data.ResponseCode !== undefined ? res.data.ResponseCode : res.data.responseCode
    const responseMessage = res.data.ResponseMessage !== undefined ? res.data.ResponseMessage : res.data.responseMessage
    
    if (responseCode === CONSTANTS.SUCCESS) {
      responseData.allCountry = res.data.Result || res.data.result || []
      const countries = res.data.Result || res.data.result || []
      countries.forEach(function (countryInfo, index) {
        // Handle both Recommended/recommended and IsCurrent/isCurrent
        const isRecommended = countryInfo.Recommended !== undefined ? countryInfo.Recommended : countryInfo.recommended
        const isCurrent = countryInfo.IsCurrent !== undefined ? countryInfo.IsCurrent : countryInfo.isCurrent
        
        if (isRecommended) {
          responseData.mostVisitedCountry.push(countryInfo)
        }
        if (isCurrent) {
          responseData.currentCountry = countryInfo
        }
      })
    } else {
      responseData.error = responseMessage || 'Failed to get family roaming countries'
    }
  } catch (e) {
    console.error('Error getting family roaming countries:', e)
    // Extract more detailed error information
    if (e.response) {
      // Server responded with error status
      const status = e.response.status
      const errorData = e.response.data
      const errorMessage = errorData?.ResponseMessage || errorData?.responseMessage || errorData?.message || `Server error (${status})`
      
      if (status === 404) {
        responseData.error = 'Family roaming service not found. Please check if the service is available.'
      } else if (status === 401 || status === 403) {
        responseData.error = 'Authentication failed. Please login again.'
      } else if (status >= 500) {
        responseData.error = 'Server error. Please try again later.'
      } else {
        responseData.error = errorMessage
      }
    } else if (e.request) {
      // Request was made but no response received
      responseData.error = 'Network error. Please check your internet connection.'
    } else {
      // Something else happened
      responseData.error = e.message || 'Error while getting family roaming countries'
    }
  }
  return responseData
}

export const getFamilyRoamingCountryBundles = async (destMsisdn, countryCodes) => {
  let responseData = { countryBundles: [], sharedBundles: [], error: null }
  try {
    const countryCodesString = countryCodes.join(',')
    // Try different possible endpoint paths
    let res
    let lastError = null
    
    // NOTE: Backend spelling is sometimes "Roamin" (without 'g').
    // Prefer that first, then fall back to the other variants.
    try {
      res = await authenticatedAxios.get(
        `${ENDPOINTS.roaming.root}/GetFamilyRoaminCountryBundles?destmsisdn=${destMsisdn}&countryCodes=${countryCodesString}`
      )
    } catch (error1) {
      lastError = error1
      // Try 2: Same root, but "Roaming" spelling
      if (error1.response?.status === 404) {
        try {
          res = await authenticatedAxios.get(
            `${ENDPOINTS.roaming.root}/GetFamilyRoamingCountryBundles?destmsisdn=${destMsisdn}&countryCodes=${countryCodesString}`
          )
        } catch (error2) {
          lastError = error2
          // Try 3: Relative path without leading slash
          if (error2.response?.status === 404) {
            try {
              res = await authenticatedAxios.get(
                `Roaming/GetFamilyRoaminCountryBundles?destmsisdn=${destMsisdn}&countryCodes=${countryCodesString}`
              )
            } catch (error3) {
              lastError = error3
              throw error3
            }
          } else {
            throw error2
          }
        }
      } else {
        throw error1
      }
    }
    
    // Handle both ResponseCode (API spec) and responseCode (common pattern)
    const responseCode = res.data.ResponseCode !== undefined ? res.data.ResponseCode : res.data.responseCode
    const responseMessage = res.data.ResponseMessage !== undefined ? res.data.ResponseMessage : res.data.responseMessage
    const result = res.data.Result !== undefined ? res.data.Result : res.data.result
    
    if (responseCode === CONSTANTS.SUCCESS) {
      // Normalize to the same shape as getCountryBundlesV2:
      // { countryBundles: [ { Country, listOfBundles } ], sharedBundles: [...] }
      if (Array.isArray(result)) {
        // API returned a flat list of bundles (no country wrapper).
        const bundles = result || []
        // Group by countryCode to simulate countryBundles structure.
        const byCountry = bundles.reduce((acc, b) => {
          const code = b.countryCode ?? b.CountryCode
          const key = code != null ? String(code) : 'unknown'
          if (!acc[key]) {
            acc[key] = {
              Country: {
                CountryCode: code,
                CountryName: b.countryName || b.CountryName || '',
              },
              listOfBundles: [],
            }
          }
          acc[key].listOfBundles.push(b)
          return acc
        }, {})

        responseData.countryBundles = Object.values(byCountry)
        responseData.sharedBundles = []
      } else {
        const obj = result || {}
        responseData.countryBundles = obj.countryBundles || []
        responseData.sharedBundles = obj.sharedBundles || []
      }
    } else {
      responseData.error = responseMessage
      responseData.responseCode = responseCode
      responseData.responseMessage = responseMessage
    }
  } catch (e) {
    console.error('Error getting family roaming country bundles:', e)
    // Extract more detailed error information
    if (e.response) {
      const status = e.response.status
      const errorData = e.response.data
      const errorMessage = errorData?.ResponseMessage || errorData?.responseMessage || errorData?.message || `Server error (${status})`
      
      if (status === 404) {
        responseData.error = 'Family roaming bundles not found. Please check if the service is available.'
      } else if (status === 401 || status === 403) {
        responseData.error = 'Authentication failed. Please login again.'
      } else if (status >= 500) {
        responseData.error = 'Server error. Please try again later.'
      } else {
        responseData.error = errorMessage
        // Include responseCode if available in error response
        const errorResponseCode = errorData?.ResponseCode !== undefined ? errorData?.ResponseCode : errorData?.responseCode
        if (errorResponseCode !== undefined) {
          responseData.responseCode = errorResponseCode
          responseData.responseMessage = errorMessage
        }
      }
    } else if (e.request) {
      responseData.error = 'Network error. Please check your internet connection.'
    } else {
      responseData.error = e.message || 'Error while getting family roaming country bundles'
    }
  }
  return responseData
}

export const isFamilyRoamingAllowedToPurchase = async () => {
  let responseData = { allowed: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `/CustomerInfo/GetCustomerInfoLite`
    )
    
    // Handle both ResponseCode (API spec) and responseCode (common pattern)
    const responseCode = res.data.ResponseCode !== undefined ? res.data.ResponseCode : res.data.responseCode
    const responseMessage = res.data.ResponseMessage !== undefined ? res.data.ResponseMessage : res.data.responseMessage
    const result = res.data.Result !== undefined ? res.data.Result : res.data.result
    
    if (responseCode === CONSTANTS.SUCCESS) {
      // Extract familyRoamingAllowedToPurchase from customer info result
      responseData.allowed = result?.familyRoamingAllowedToPurchase || false
    } else {
      responseData.error = responseMessage || 'Failed to check purchase eligibility'
    }
  } catch (e) {
    console.error('Error checking family roaming purchase eligibility:', e)
    const errorMessage = e.response?.data?.ResponseMessage || e.response?.data?.responseMessage || e.message
    responseData.error = errorMessage || 'Error while checking family roaming purchase eligibility'
  }
  return responseData
}

export const getFamilyRoamingOffersPrice = async (details) => {
  let responseData = { price: 0, discount: 0, discountPercent: '0%', net: 0, listOfKeysValues: [], error: null, responseCode: null, responseMessage: null }
  try {
    const res = await authenticatedAxios.post(
      `/Roaming/GetOffersPrice`,
      { details }
    )
    // Handle both ResponseCode (API spec) and responseCode (common pattern)
    const responseCode = res.data.ResponseCode !== undefined ? res.data.ResponseCode : res.data.responseCode
    const responseMessage = res.data.ResponseMessage !== undefined ? res.data.ResponseMessage : res.data.responseMessage
    const result = res.data.Result !== undefined ? res.data.Result : res.data.result
    
    // Store responseCode and responseMessage for caller to check
    responseData.responseCode = responseCode
    responseData.responseMessage = responseMessage
    
    if (responseCode === CONSTANTS.SUCCESS) {
      const normalizeKey = (key) =>
        key ? key.toString().trim().toLowerCase() : ''
      const isPriceKey = (key) => {
        const normalized = normalizeKey(key)
        return ['price', 'السعر', 'total price'].includes(normalized)
      }
      const isDiscountKey = (key) => {
        const normalized = normalizeKey(key)
        return ['discount', 'الخصم', 'خصم'].includes(normalized)
      }
      const isNetKey = (key) => {
        const normalized = normalizeKey(key)
        return ['net', 'المجموع', 'total', 'summary', 'sum'].includes(normalized)
      }
      const parseNumericValue = (value) => {
        if (typeof value === 'number') {
          return value
        }
        if (typeof value === 'string') {
          const normalized = value
            .replace(/[^\d.,-]/g, ' ')
            .replace(/,/g, '')
            .trim()
          const match = normalized.match(/-?\d+(\.\d+)?/)
          if (match) {
            return parseFloat(match[0])
          }
        }
        return null
      }
      const normalizePercent = (value) => {
        if (typeof value === 'string') {
          const trimmed = value.replace(/\s+/g, '')
          if (trimmed.includes('%')) {
            return trimmed
          }
        }
        if (typeof value === 'number') {
          return `${value}%`
        }
        return null
      }

      const listOfValues =
        Array.isArray(result)
          ? result
          : Array.isArray(result?.ListOfKeysValues)
            ? result.ListOfKeysValues
            : Array.isArray(result?.listOfKeysValues)
              ? result.listOfKeysValues
              : []
      
      // Store listOfKeysValues for direct use in UI
      responseData.listOfKeysValues = listOfValues

      const priceFromObject =
        result && typeof result === 'object' && !Array.isArray(result)
          ? result.price ?? result.Price ?? null
          : null

      if (priceFromObject !== null) {
        responseData.price = parseFloat(priceFromObject) || 0
      }

      if (
        result &&
        typeof result === 'object' &&
        !Array.isArray(result) &&
        (result.net !== undefined || result.Net !== undefined)
      ) {
        const netValue = result.net ?? result.Net
        responseData.net = parseFloat(netValue) || 0
      }

      let pendingDiscountPercent = null

      listOfValues.forEach((item) => {
        const key = item.key || item.Key
        const value = item.value || item.Value
        if (isPriceKey(key)) {
          const parsedPrice = parseNumericValue(value)
          if (parsedPrice !== null) {
            responseData.price = parsedPrice
          }
        } else if (isDiscountKey(key)) {
          if (typeof value === 'string' && value.includes('%')) {
            const percentMatch = parseNumericValue(value)
            if (percentMatch !== null) {
              pendingDiscountPercent = percentMatch
              responseData.discountPercent = normalizePercent(percentMatch) || responseData.discountPercent
            }
          } else {
            const parsedDiscount = parseNumericValue(value)
            if (parsedDiscount !== null) {
              responseData.discount = parsedDiscount
            }
          }
        } else if (isNetKey(key)) {
          const parsedNet = parseNumericValue(value)
          if (parsedNet !== null) {
            responseData.net = parsedNet
          }
        }
      })

      if (pendingDiscountPercent !== null) {
        if (!responseData.discountPercent || responseData.discountPercent === '0%') {
          responseData.discountPercent = normalizePercent(pendingDiscountPercent) || '0%'
        }
        if ((!responseData.discount || responseData.discount === 0) && responseData.price) {
          responseData.discount = (responseData.price * pendingDiscountPercent) / 100
        }
      } else if (
        (!responseData.discountPercent || responseData.discountPercent === '0%') &&
        responseData.discount > 0 &&
        responseData.price > 0
      ) {
        responseData.discountPercent = `${((responseData.discount / responseData.price) * 100).toFixed(0)}%`
      }

      if (!responseData.net && responseData.price) {
        responseData.net = responseData.price - (responseData.discount || 0)
      }

      if (!responseData.price && responseData.net) {
        responseData.price = responseData.net + (responseData.discount || 0)
      }

      // If net still zero but we have price/discount, derive it
      if (!responseData.net && responseData.price) {
        responseData.net =
          responseData.price - (responseData.discount || 0)
      }
    } else {
      responseData.error = responseMessage || 'Failed to get offers price'
    }
  } catch (e) {
    console.error('Error getting family roaming offers price:', e)
    const errorMessage = e.response?.data?.ResponseMessage || e.response?.data?.responseMessage || e.message
    responseData.error = errorMessage || 'Error while getting family roaming offers price'
  }
  return responseData
}

export const subscribeFamilyRoamingBundles = async (details) => {
  let responseData = { success: false, message: '', error: null }
  try {
    const res = await authenticatedAxios.post(
      `/Roaming/SubscribeFamilyRoamingBundles`,
      { details }
    )
    // Handle both responseCode (API spec) and ResponseCode (common pattern)
    const responseCode = res.data.responseCode !== undefined ? res.data.responseCode : res.data.ResponseCode
    const responseMessage = res.data.responseMessage !== undefined ? res.data.responseMessage : res.data.ResponseMessage
    
    if (responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
      responseData.message = responseMessage || 'Success'
    } else {
      responseData.error = responseMessage || 'Failed to subscribe family roaming bundles'
    }
  } catch (e) {
    console.error('Error subscribing family roaming bundles:', e)
    const errorMessage = e.response?.data?.responseMessage || e.response?.data?.ResponseMessage || e.message
    responseData.error = errorMessage || 'Error while subscribing family roaming bundles'
  }
  return responseData
}

// Groups API functions
export const getGroups = async () => {
  let responseData = { groups: [], error: null }
  try {
    const res = await authenticatedAxios.get(ENDPOINTS.groups.getGroups)
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.groups = res.data.result || []
    } else {
      responseData.error = res.data.responseMessage || 'Failed to get groups'
    }
  } catch (e) {
    console.error('Error getting groups:', e)
    responseData.error = e.response?.data?.responseMessage || e.message || 'Error while getting groups'
  }
  return responseData
}

export const createGroup = async (groupData) => {
  let responseData = { groupId: null, error: null }
  try {
    const res = await authenticatedAxios.post(
      ENDPOINTS.groups.createGroup,
      groupData
    )
    console.log('Create group response:', res.data)
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.groupId = res.data.result
    } else {
      responseData.error = res.data.responseMessage || 'Failed to create group'
    }
  } catch (e) {
    console.error('Error creating group:', e)
    responseData.error = e.response?.data?.responseMessage || e.message || 'Error while creating group'
  }
  return responseData
}

export const updateGroup = async (groupData) => {
  let responseData = { success: false, error: null }
  try {
    const res = await authenticatedAxios.post(
      ENDPOINTS.groups.updateGroup,
      groupData
    )
    if (res.data.responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
    } else {
      responseData.error = res.data.responseMessage
    }
  } catch (e) {
    responseData.error = 'Error while updating group'
  }
  return responseData
}

export const deleteGroup = async (groupId) => {
  let responseData = { success: false, error: null }
  try {
    const res = await authenticatedAxios.get(
      `${ENDPOINTS.groups.deleteGroup}?groupId=${groupId}`,
      {
        // Configure to accept HTML responses
        responseType: 'text',
        transformResponse: [(data) => {
          // Try to parse as JSON first
          try {
            return JSON.parse(data)
          } catch (e) {
            // If not JSON, return as string
            return data
          }
        }]
      }
    )
    
    // Handle HTML response (API sometimes returns HTML instead of JSON)
    let responseDataParsed = res.data
    if (typeof res.data === 'string') {
      try {
        // Try to parse as JSON if it's a string
        responseDataParsed = JSON.parse(res.data)
      } catch (parseError) {
        // If parsing fails, check if it's HTML or empty response
        // For GET requests, a 200 status with HTML might indicate success
        if (res.status === 200) {
          responseData.success = true
          return responseData
        }
        responseData.error = 'Invalid response format from server'
        return responseData
      }
    }
    
    if (responseDataParsed && responseDataParsed.responseCode === CONSTANTS.SUCCESS) {
      responseData.success = true
    } else {
      responseData.error = responseDataParsed?.responseMessage || 'Failed to delete group'
    }
  } catch (e) {
    console.error('Error deleting group:', e)
    // Handle case where error.response might be undefined
    if (e.response) {
      // For GET with 200 status, even if HTML, consider success
      if (e.response.status === 200) {
        responseData.success = true
        return responseData
      }
      // Try to parse HTML response in error case too
      let errorData = e.response.data
      if (typeof errorData === 'string') {
        try {
          errorData = JSON.parse(errorData)
        } catch (parseError) {
          // If still can't parse and status is 200, consider success
          if (e.response.status === 200) {
            responseData.success = true
            return responseData
          }
        }
      }
      responseData.error = errorData?.responseMessage || e.message || 'Error while deleting group'
    } else {
      // Network error or other issues
      // If it's a network error but we got a 200 status code, it might still be successful
      responseData.error = e.message || 'Error while deleting group'
    }
  }
  return responseData
}

export const getTermsAndConditions = async (language = null) => {
  let responseData = { terms: '', error: null }
  try {
    // Prepare config with language header if provided
    // Normalize language to uppercase (AR/EN) as expected by the API
    const config = {}
    if (language) {
      const normalizedLang = language.toUpperCase()
      config.headers = {
        Lang: normalizedLang
      }
    }
    const res = await authenticatedAxios.get(`${ENDPOINTS.roaming.root}/TermsAndConditions`, config)
    // Handle both responseCode (API spec) and ResponseCode (common pattern)
    const responseCode = res.data.responseCode !== undefined ? res.data.responseCode : res.data.ResponseCode
    const responseMessage = res.data.responseMessage !== undefined ? res.data.responseMessage : res.data.ResponseMessage
    const result = res.data.result !== undefined ? res.data.result : res.data.Result
    
    if (responseCode === CONSTANTS.SUCCESS) {
      responseData.terms = result || ''
    } else {
      responseData.error = responseMessage || 'Failed to get terms and conditions'
    }
  } catch (e) {
    console.error('Error getting terms and conditions:', e)
    const errorMessage = e.response?.data?.responseMessage || e.response?.data?.ResponseMessage || e.message
    responseData.error = errorMessage || 'Error while getting terms and conditions'
  }
  return responseData
}